import {
  quickshopButtonGrid,
  quickshopDrawerBlueprint,
  quickshopOneSizeButtonBlueprint,
  swatchesBlueprint,
  template1Styling,
  badgesBlueprint,
} from "@made-people/blueprint-product-card/blueprint";

badgesBlueprint.override({
  slots: {
    wrapper: "z-20 gap-2 flex m-2 md:m-3 lg:m-4",
    badge:
      "inline-flex bg-black text-white py-1.5 px-1.5 text-label-sm font-medium font-primary rounded-md",
  },
  variants: {
    placeIn: {
      gallery: {
        wrapper: "absolute z-20",
      },
      details: {
        wrapper: "",
      },
    },
    position: {
      topRight: {
        wrapper: "top-0 right-0",
      },
      topLeft: {
        wrapper: "top-0 left-0",
      },
      bottomRight: {
        wrapper: "bottom-0 right-0",
      },
      bottomLeft: {
        wrapper: "bottom-0 left-0",
      },
    },
    isVisible: {
      true: {
        wrapper: "visible",
      },
      false: {
        wrapper: "hidden",
      },
    },
  },
  defaultVariants: {
    placeIn: "gallery",
    isVisible: "true",
    position: "topLeft",
  },
});

template1Styling.main.override({
  slots: {
    wrapper:
      "group relative flex flex-col group/product-card group-hover/product-list:brightness-95 group-hover/swiper:brightness-90 hover:!brightness-100 transition-all duration-300 ease-in-out",
  },
});

template1Styling.gallery.override({
  slots: {
    wrapper: "relative aspect-product-image overflow-hidden",
    imageWrapper:
      "w-full h-full transition-all z-10 relative object-cover flex aspect-product-image",
    image: "top-0 bottom-0 left-0 right-0 object-cover absolute h-full w-full",
    productLink: "absolute block top-0 left-0 right-0 bottom-0 z-10",
  },
  variants: {
    rounded: {
      true: {
        wrapper: "rounded-md",
      },
      false: {
        wrapper: "",
      },
    },
    hoverEffect: {
      changeImage: {
        imageWrapper: "",
        image:
          "transition-opacity duration-300 first:z-[1] opacity-0 first:opacity-100 first:group-hover:opacity-0 [&:nth-child(2)]:opacity-0 [&:nth-child(2)]:group-hover:opacity-100",
      },
      scaleImage: {
        image:
          "group-hover:scale-[1.05] transition-transform opacity-0 first:opacity-100",
      },
    },
  },
  defaultVariants: {
    rounded: "true",
    hoverEffect: "scaleImage",
  },
});

quickshopDrawerBlueprint.override({
  slots: {
    base: "relative rounded-lg w-full",
    baseWrapper:
      "px-0 py-3 group data-[has-multiple-options=false]:py-0 lg:min-w-[448px] max-w-[448px]",
    trigger:
      "z-30 absolute p-2 bg-white lg:data-[is-one-size=true]:block rounded-full",
    wrapper:
      "w-full flex flex-col gap-x-1.5 gap-y-3 py-5 group-data-[has-multiple-options=false]:pt-3 group-data-[has-multiple-options=false]:gap-y-4",
    sizeLabel: "text-heading-sm font-bold",
    sizes: "flex flex-row flex-wrap gap-3 w-full",
    size: "w-14 h-14 flex items-center justify-center rounded-full border border-neutral-200 text-label-md text-neutral-600 transition-colors hover:border-neutral-400 data-[is-out-of-stock='true']:bg-out-of-stock-bg data-[is-out-of-stock='true']:border-out-of-stock-bg data-[is-out-of-stock='true']:text-out-of-stock-label data-[is-out-of-stock='true']:cursor-default data-[is-out-of-stock='true']:[--default-bg:theme(colors.out-of-stock.bg)] data-[is-out-of-stock='true']:[--disabled-bg:theme(colors.out-of-stock.bg)] data-[is-out-of-stock='true']:[--default-label:theme(colors.out-of-stock.label)] data-[is-out-of-stock='true']:[--disabled-label:theme(colors.out-of-stock.label)] data-[is-out-of-stock='true']:[--border:theme(colors.out-of-stock.bg)] data-[is-selected=true]:bg-black data-[is-selected=true]:text-white data-[is-selected=true]:border-black data-[is-selected=true]:[--active-bg:black] data-[is-selected=true]:[--active-label:white]",
    header: "col-span-auto text-left",
    heading: "text-heading-md",

    productInfo:
      "col-span-2  grid-cols-[142px_1fr] grid-rows-[min-content_1fr] mt-5 gap-x-3 hidden group-data-[is-one-size=true]:grid",
    productImage:
      "col-span-1 aspect-product-image rounded-lg overflow-hidden row-span-2 w-full",
    productName: "col-start-2 col-end-3 text-body-md  row-span-1 mb-2",
    productPriceWrapper:
      "flex flex-col col-start-2 col-end-3 text-left row-span-1",
    productPriceBeforeDiscount:
      "line-through text-body-sm lg:text-body-md text-less-emphasis-1",
    productPrice:
      "text-body-md lg:text-body-lg  lg: data-[is-discounted=true]:text-sale-price text-left",
    optionGroupsWrapper: "flex flex-col-reverse",
    addToCartButton: "col-span-3 mt-4 gap-2 flex flex-col w-full",
  },
  variants: {
    triggerPosition: {
      "top-left": { trigger: "top-0 left-0" },
      "top-right": { trigger: "top-3 right-3" },
      "bottom-left": { trigger: "bottom-0 left-0" },
      "bottom-right": { trigger: "bottom-2 right-2" },
    },
    placeIn: {
      details: {
        base: "z-30 col-span-4 bg-surface-1",
      },
      gallery: {
        base: "absolute bg-white flex group-hover:translate-y-0 translate-y-[calc(100%+24px)] transition-transform duration-300 left-6 right-6 bottom-6",
      },
    },
  },
  defaultVariants: {
    triggerPosition: "top-right",
  },
});

quickshopOneSizeButtonBlueprint.override({
  slots: {
    base: "z-30 col-span-4 mt-1 data-[is-out-of-stock=true]:hidden order-4 lg:flex",
  },
  variants: {
    placeIn: {
      details: {
        base: "z-30 col-span-4 mt-1 data-[is-out-of-stock=true]:hidden order-4 lg:hidden mb-4",
      },
      gallery: {
        base: "absolute flex z-30 group-hover:translate-y-0 translate-y-[calc(100%+24px)] transition-transform duration-300 left-6 right-6 bottom-4",
      },
    },
  },
});
quickshopButtonGrid.override({
  slots: {
    base: "rounded-lg z-30",
    wrapper: "flex justify-center w-full py-0.5 px-0.5",
    size: "w-9 max-w-9 rounded-md data-[is-out-of-stock='true']:bg-out-of-stock-bg data-[is-out-of-stock='true']:border-out-of-stock-bg data-[is-out-of-stock='true']:[--default-bg:theme(colors.out-of-stock.bg)] data-[is-out-of-stock='true']:[--disabled-bg:theme(colors.out-of-stock.bg)] data-[is-out-of-stock='true']:[--default-label:theme(colors.out-of-stock.label)] data-[is-out-of-stock='true']:[--disabled-label:theme(colors.out-of-stock.label)] data-[is-out-of-stock='true']:[--border:theme(colors.out-of-stock.bg)] data-[is-out-of-stock='true']:cursor-default data-[appear-disabled=true]:[--disabled-bg:theme(colors.out-of-stock.bg)] data-[appear-disabled=true]:[--disabled-label:theme(colors.out-of-stock.label)] data-[appear-disabled=true]:[--border:theme(colors.out-of-stock.bg)] data-[appear-disabled=true]:cursor-default",
  },
  variants: {
    showOnlyOnDesktop: {
      true: {
        base: "hidden lg:hidden",
      },
      false: {
        base: "",
      },
    },
    placeIn: {
      details: {
        base: "z-30 col-span-4 bg-surface-1",
      },
      gallery: {
        base: "absolute bg-[#FFFFFF] flex group-hover:translate-y-0 translate-y-[calc(100%+24px)] transition-transform duration-300 left-4 right-4 bottom-4",
      },
    },
  },
  defaultVariants: {
    showOnlyOnDesktop: "true",
    placeIn: "gallery",
  },
});

swatchesBlueprint.override({
  slots: {
    wrapper: "z-20 mt-4 order-3 mb-0.5 empty:hidden",
    swatches: "flex gap-2 px-px py-0.5 items-center",
    overflow: "text-xs leading-none opacity-80",
    swatch:
      "w-3 h-3 min-w-3 min-h-3 rounded-full hover:scale-110 transition-transform data-[selected=true]:outline-neutral-400 outline-1 outline outline-transparent outline-offset-1 data-[is-white=true]:outline-black/10 overflow-x-scroll",
  },
  variants: {
    placeIn: {
      gallery: {
        wrapper: "z-20 absolute bottom-3 left-3 lg:bottom-6 lg:left-6",
      },
      details: {
        wrapper: "col-span-4",
      },
    },
    isVisible: {
      true: {
        wrapper: "",
      },
      false: {
        wrapper: "hidden",
      },
    },
  },
  defaultVariants: {
    isVisible: "true",
  },
});

template1Styling.details.override({
  slots: {
    detailsWrapper: "relative pt-3 flex flex-col",
    detailsLink: "absolute block top-0 left-0 right-0 bottom-0 z-20",

    // Product Information
    name: "text-heading-sm",
    shortDescription: "text-body-sm text-less-emphasis-1 hidden",
    productInfoText: "text-heading-xs mt-1.5 text-beige-700",

    // Price
    priceWrapper: "text-heading-sm flex gap-1 items-center lg:gap-1.5 mt-1",
    price: "leading-none",
    priceBeforeDiscount: "leading-none line-through text-sale-price font-[400]",
  },
  variants: {
    spacing: {
      true: {
        detailsWrapper: "px-4",
      },
      false: {
        detailsWrapper: "px-0",
      },
    },
  },
  defaultVariants: {
    spacing: "false",
  },
});
